// extracted by mini-css-extract-plugin
export default {"block":"CartEmpty_block__+1DvK","image":"CartEmpty_image__3LiD9","title":"CartEmpty_title__QVLfi","subtitle":"CartEmpty_subtitle__0PAE6"};